export default "__VITE_ASSET__BadeV7ab__"